/*** IMPORTS FROM imports-loader ***/
var $ = window.jQuery;

// removed by extract-text-webpack-plugin



//////////////////
// WEBPACK FOOTER
// ./node_modules/imports-loader?$=>window.jQuery!./src/wp-migrate-db-pro/asset/src/sass/_migration-progress.scss
// module id = 129
// module chunks = 0